// extracted by mini-css-extract-plugin
export const formDiv = "contact-module--formDiv--tb13j";
export const nameEmail = "contact-module--nameEmail--3atiV";
export const name = "contact-module--name--2YtBI";
export const email = "contact-module--email--1ffCl";
export const textAreaButton = "contact-module--textAreaButton--2kAzQ";
export const textArea = "contact-module--textArea--2XdIR";
export const submitButton = "contact-module--submitButton--27fOq";
export const hiddenField = "contact-module--hiddenField--1InQl";